import { render, staticRenderFns } from "./InfoGoodsSwipe.vue?vue&type=template&id=f65832c0&scoped=true"
import script from "./InfoGoodsSwipe.vue?vue&type=script&lang=js"
export * from "./InfoGoodsSwipe.vue?vue&type=script&lang=js"
import style0 from "./InfoGoodsSwipe.vue?vue&type=style&index=0&id=f65832c0&prod&lang=scss"
import style1 from "./InfoGoodsSwipe.vue?vue&type=style&index=1&id=f65832c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65832c0",
  null
  
)

export default component.exports